import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectErrorSession,
  selectUser,
} from "../store/slices/session/sessionSelector";
import { setToastMessage } from "../store/slices/app/appSlice";
import { sessionError } from "../store/slices/session/sessionSlice";

const UnauthenticatedRoute: React.FC = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const errorSession = useSelector(selectErrorSession);
  const location = useLocation();
  // Tras el login se vuelve a la página que lo pidió (p. ej. la de conectar Claude)
  const from = (
    location.state as { from?: { pathname: string; search?: string } } | null
  )?.from;

  useEffect(() => {
    if (errorSession) {
      dispatch(
        setToastMessage({
          message: errorSession?.message || "Unexpected Error",
          severity: "error",
        })
      );
      dispatch(sessionError(null));
    }
  }, [dispatch, errorSession]);

  return !user ? (
    <Outlet />
  ) : (
    <Navigate
      to={from ? `${from.pathname}${from.search ?? ""}` : "/"}
      replace
    />
  );
};

export default UnauthenticatedRoute;
